export const healthcareTranslations = {
  // 医疗保健相关翻译
  "lifeServices": {
    en: "Life Services",
    zh: "生活服务"
  },
  "healthcare": {
    en: "Healthcare",
    zh: "医疗保健"
  },
  "healthcareTitle": {
    en: "Healthcare in Penang",
    zh: "槟城医疗保健"
  },
  "healthcareDesc": {
    en: "Penang offers excellent medical facilities with international standards and English-speaking professionals.",
    zh: "槟城提供国际标准的优质医疗设施和会说英语的专业人员。"
  },
  "medicalFacilities": {
    en: "Medical Facilities",
    zh: "医疗设施"
  },
  "privateHospitals": {
    en: "Top private hospitals: Penang Adventist, Gleneagles, Island Hospital",
    zh: "顶级私立医院：槟城三育医院、格兰伊格尔斯医院、岛屿医院"
  },
  "publicHospitals": {
    en: "Government hospitals: Penang General Hospital, Seberang Jaya Hospital",
    zh: "政府医院：槟城中央医院、十八丁再也医院"
  },
  "specialtyClinics": {
    en: "Numerous specialty clinics and dental practices throughout the island",
    zh: "岛上遍布众多专科诊所和牙科诊所"
  },
  "doctorsEnglish": {
    en: "Many doctors speak English",
    zh: "许多医生会说英语"
  },
  "pharmacies": {
    en: "Pharmacies widely available",
    zh: "药店广泛可用"
  },
  "healthcareGuide": {
    en: "Healthcare Guide",
    zh: "医疗保健指南"
  },
  "medicalInsurance": {
    en: "Medical Insurance",
    zh: "医疗保险"
  },
  "insuranceRecommendation": {
    en: "We strongly recommend having comprehensive medical insurance coverage during your stay in Penang.",
    zh: "我们强烈建议您在槟城逗留期间拥有全面的医疗保险。"
  },
  "insuranceOptions": {
    en: "Insurance Options",
    zh: "保险选择"
  },
  "localInsurance": {
    en: "Local insurance providers like AIA, Prudential, and Allianz offer health plans for expats and long-term visitors.",
    zh: "AIA、保诚和安联等本地保险提供商为外籍人士和长期访客提供健康计划。"
  },
  "internationalInsurance": {
    en: "International travel insurance with medical coverage is essential for short-term visitors.",
    zh: "包含医疗保障的国际旅行保险对短期访客至关重要。"
  },
  "studentInsurance": {
    en: "Most universities provide basic medical insurance for international students, but supplementary coverage is recommended.",
    zh: "大多数大学为国际学生提供基本医疗保险，但建议补充保险。"
  },
  "emergencyServices": {
    en: "Emergency Services",
    zh: "紧急服务"
  },
  "emergencyNumber": {
    en: "Emergency Number: 999 for police, fire, and ambulance services",
    zh: "紧急电话：999（警察、消防和救护服务）"
  },
  "hospitalEmergency": {
    en: "Major hospitals have 24-hour emergency departments",
    zh: "主要医院设有24小时急诊部"
  },
  "touristPolice": {
    en: "Tourist Police: +604-261 9999 for assistance specific to visitors",
    zh: "旅游警察：+604-261 9999（专为访客提供协助）"
  },
  "commonAilments": {
    en: "Common Health Concerns",
    zh: "常见健康问题"
  },
  "heatRelated": {
    en: "Heat-related issues: Stay hydrated and use sun protection in Penang's tropical climate",
    zh: "与热相关的问题：在槟城的热带气候中保持水分摄入并使用防晒措施"
  },
  "foodSafety": {
    en: "Food safety: While street food is generally safe, choose busy stalls with high turnover",
    zh: "食品安全：虽然街头食品通常安全，但选择客流量大的摊位"
  },
  "mosquitoBorne": {
    en: "Mosquito-borne diseases: Use insect repellent, especially during dawn and dusk",
    zh: "蚊媒疾病：使用驱蚊剂，尤其在黎明和黄昏时分"
  },
  "healthTips": {
    en: "Health Tips for Visitors",
    zh: "访客健康贴士"
  },
  "waterSafety": {
    en: "Tap water is treated but many people prefer bottled water for drinking",
    zh: "自来水经过处理，但许多人喜欢饮用瓶装水"
  },
  "vaccinationRecommendations": {
    en: "Standard vaccinations should be up-to-date before visiting Malaysia",
    zh: "在访问马来西亚前应确保标准疫苗接种是最新的"
  },
  "pharmacyOTC": {
    en: "Pharmacies can provide over-the-counter remedies for minor ailments",
    zh: "药店可提供非处方药物治疗轻微不适"
  },
  "sunProtection": {
    en: "Use sunscreen, hats, and stay hydrated in the tropical climate",
    zh: "在热带气候中使用防晒霜、戴帽子并保持水分摄入"
  },
  "banking": {
    en: "Banking",
    zh: "银行"
  },
  "bankingDesc": {
    en: "Opening a local bank account makes financial transactions easier during your stay in Penang, especially for long-term residents.",
    zh: "开设本地银行账户可使您在槟城逗留期间的金融交易更加便捷，特别是对长期居民而言。"
  },
  "majorBanks": {
    en: "Major Banks",
    zh: "主要银行"
  },
  "localBanks": {
    en: "Local banks: Maybank, CIMB, Public Bank, RHB",
    zh: "本地银行：马来亚银行、联昌国际银行、大众银行、兴业银行"
  },
  "internationalBanks": {
    en: "International banks: HSBC, Standard Chartered, Citibank",
    zh: "国际银行：汇丰银行、渣打银行、花旗银行"
  },
  "documentationRequired": {
    en: "Documentation Required",
    zh: "所需文件"
  },
  "passportRequired": {
    en: "Passport and visa/permit",
    zh: "护照和签证/许可证"
  },
  "proofOfAddress": {
    en: "Proof of address in Penang (rental agreement or utility bill)",
    zh: "槟城地址证明（租赁协议或公用事业账单）"
  },
  "referenceLetters": {
    en: "Reference letters may be required by some banks",
    zh: "某些银行可能要求推荐信"
  },
  "atms": {
    en: "ATMs",
    zh: "自动取款机"
  },
  "widelyAvailable": {
    en: "Widely available throughout Penang",
    zh: "在槟城各处广泛可用"
  },
  "withdrawalFees": {
    en: "Foreign card withdrawal fees typically range from RM10-20 per transaction",
    zh: "外国卡取款费用通常为每笔交易10-20林吉特"
  },
  "dailyLimits": {
    en: "Daily withdrawal limits apply, usually around RM5,000",
    zh: "适用每日提款限额，通常约为5,000林吉特"
  },
  "currencyExchange": {
    en: "Currency Exchange",
    zh: "货币兑换"
  },
  "moneyChangers": {
    en: "Licensed money changers often offer better rates than banks",
    zh: "持牌货币兑换商通常提供比银行更好的汇率"
  },
  "popularLocations": {
    en: "Popular locations: Shopping malls, Georgetown tourist areas, airport",
    zh: "热门地点：购物中心、乔治城旅游区、机场"
  },
  "exchangeDocumentation": {
    en: "Passport may be required for larger transactions",
    zh: "较大交易可能需要出示护照"
  }
};
